module.exports = __webpack_public_path__ + "static/media/pool_page_bg.4ab8a7e6.jpeg";